export enum GameTabs {
  'saved',
  'submitted',
  'used',
}

export enum TMGameListTabs {
  'games' = 'Games',
  'templates' = 'Templates',
}